<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <perfect-scrollbar
      class="scroll-area"
      :settings="settings"
      @ps-scroll-y="scrollHanle"
    >
      <div v-if="isVertical" class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="clinicdropdown">
              <router-link :to=" user.roles?.[0] === 'super_admin' ? '/companies' : '/settings/profile'">
                <img
                v-if="user.image"
                  :src="user.image"
                  class="img-fluid"
                  alt="Profile"
                />
                <img
                v-else
                  src='@/assets/img/profiles/avatar.svg'
                  class="img-fluid"
                  alt="Profile"
                />
                <div class="user-names">
                  <h5>{{ user.first_name }} {{ user.last_name }}</h5>
                  <h6>{{ user.company_name }}</h6>
                </div>
              </router-link>
            </li>
          </ul>
          <vertical-sidebar></vertical-sidebar>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { mapGetters, mapActions } from 'vuex';
import { computed, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      // isVertical: true,
      settings: {
        suppressScrollX: true,
      },
    };
  },
  setup(){
    const store = useStore();
    const isVertical = computed(() => store.getters["changelayout/getHeader"]);
       // Watch for changes in isVertical and update body class
       watch(isVertical, (newValue) => {
      updateBodyClass(newValue);
    });
    onMounted(() => {
      updateBodyClass(isVertical.value);
    });
    const updateBodyClass = (value) => {
      const body = document.body;
      if (value) {
        body.classList.add("expand-menu");
        body.classList.remove("mini-sidebar");
      } else {
        body.classList.add("mini-sidebar");
        body.classList.remove("expand-menu");
      }
    };
    return{
      isVertical,
      updateBodyClass
    }
  },
  computed: {
    ...mapGetters('auth', ['user']), // 'auth' is the namespace of your Vuex module
    
  },
  mounted() {
    // this.isVertical = JSON.parse(localStorage.getItem('isVertical'))
    // const body = document.body;
    // if(this.isVertical){
    //   body.classList.add('expand-menu');
    // } else{ 
    //   body.classList.remove('expand-menu');
    //   body.classList.add('mini-sidebar');
    // }
    // Load user data from localStorage when the component mounts
    this.loadUserFromLocalStorage();
  },
  methods: {
    ...mapActions('auth', ['loadUserFromLocalStorage']),
    scrollHanle() {},
  },
};
</script>
